import moment from "moment-timezone";
import { tint } from "./publicBooking";

const WEEKDAYS = moment.weekdaysMin().map((d) => d.toUpperCase());

/**
 * One month as Calendly draws it: open days as light circles with bold
 * numbers, the picked day solid, today with a dot, closed days gray. Days
 * are "YYYY-MM-DD" strings in the visitor's time zone.
 */
export default function MonthGrid({
  month,
  today,
  picked,
  isOpen,
  onPick,
  accent,
}: {
  month: string; // "YYYY-MM"
  today: string;
  picked?: string;
  isOpen: (day: string) => boolean;
  onPick: (day: string) => void;
  accent: string;
}) {
  const first = moment(`${month}-01`);
  const days = Array.from({ length: first.daysInMonth() }, (_, i) =>
    first.clone().add(i, "days").format("YYYY-MM-DD")
  );

  return (
    <div className="mt-4 grid grid-cols-7 gap-y-1.5 text-center">
      {WEEKDAYS.map((name) => (
        <span
          key={name}
          className="pb-2 text-[11px] font-semibold text-gray-500"
        >
          {name}
        </span>
      ))}
      {Array.from({ length: first.day() }, (_, i) => (
        <span key={`blank-${i}`} />
      ))}
      {days.map((day) => {
        const open = isOpen(day);
        const selected = day === picked;
        return (
          <button
            key={day}
            type="button"
            disabled={!open}
            onClick={() => onPick(day)}
            aria-pressed={selected}
            aria-label={moment(day).format("dddd, MMMM D")}
            className="relative mx-auto flex h-11 w-11 items-center justify-center rounded-full text-[15px] disabled:cursor-default"
            style={
              selected
                ? { backgroundColor: accent, color: "white", fontWeight: 700 }
                : open
                ? {
                    backgroundColor: tint(accent),
                    color: accent,
                    fontWeight: 700,
                  }
                : { color: "#B8BCC2" }
            }
          >
            {Number(day.slice(8))}
            {day === today && (
              <span
                className="absolute bottom-1.5 h-1 w-1 rounded-full"
                style={{ backgroundColor: selected ? "white" : "#9CA3AF" }}
              />
            )}
          </button>
        );
      })}
    </div>
  );
}
